export const FARECLASS_BUTTON_LABEL = (appliedFareclassCount: number) =>
  `Fare class${appliedFareclassCount > 0 ? ` (${appliedFareclassCount})` : ""}`;
export const POPOVER_CTA_LABEL = "Apply";
export const RESET_CTA_TEXT = "Clear";
